import ProductGuides from "../class/ProductGuides";
import {OffCanvaMenu} from "../class/OffCanvaMenu";

$(function(){

  $(".js-product-note").text($(".js-product-note").text().charAt(0).toUpperCase() + $(".js-product-note").text().substr(1).toLowerCase());

  $('#js-toggle-search').on('click', function(){
    $("#js-toggle-overlay").css('display', 'block');
  });

  $('#js-hide-filters').on('click', function(){
    $("#js-toggle-overlay").css('display', 'none');
  });

  $(window).on('resize', function(){
    $("#js-toggle-overlay").css('display', '');
  })

  var url = window.location.pathname;
  url = url.split('/');

  if(url[1] !== null && url[2] !== null && url[3] !== null){
    $(".js-product-back").attr('href', `/${url[1]}/${url[2]}/${url[4]}/${url[5]}/`);
  }
});

const Guide = new ProductGuides("#js-product-guides");
Guide.init();

new OffCanvaMenu('.js-menu-overlay-container', function(){}, function(){
  const sourceDiv = $("#js-product-guides-results-bk");
  const targetDiv = $("#js-product-guides-results");

  const htmlContent = sourceDiv.html();

  // Step 3: Set the retrieved HTML content as the innerHTML of the target div
  targetDiv.html(htmlContent);
}).init();


